<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  created() {
    new Promise(function (resolve, reject) {
      try {
        var xhr = new XMLHttpRequest();
        xhr.open("GET", require('@/assets/img/back.jpg'));
        xhr.responseType = "blob";
        xhr.onerror = function () { reject("Network error.") };
        xhr.onload = function () {
          if (xhr.status === 200) { resolve(xhr.response) }
          else { reject("Loading error:" + xhr.statusText) }
        };
        xhr.send();
      }
      catch (err) { reject(err.message) }
    }).then((blob) => {
      const blobUrl = URL.createObjectURL(blob)
      sessionStorage.setItem('backImg', blobUrl)
      document.querySelector('#app').style.backgroundImage = `url(${blobUrl})`
    })
  },
  mounted() {

  }
};
</script>

<style lang="less">
#app {
  // font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 5760px;
  height: 100vh;
  // background-image: url("@/assets/img/back.jpg");
  background-size: 100% 100%;

  // -webkit-user-select: none;
  // -moz-user-select: none;
  // -ms-user-select: none;
  // user-select: none;
}
</style>
